import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import VueSocialSharing from 'vue-social-sharing'
import Vue2TouchEvents from 'vue2-touch-events'
import LoadScript from 'vue-plugin-load-script'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// cookie consent functionality includng google analytics 
import CookieConsent from "vue-cookieconsent"
//import 'vue-cookieconsent/vendor/cookieconsent.css'
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import CookieConsentConfig from "@/consent/cookieconsent-config.js"

Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueSocialSharing)
Vue.use(Vue2TouchEvents)
Vue.use(LoadScript)
Vue.use(VuePlyr)
Vue.config.productionTip = false

//import App from './App.vue'
import Welcome from '@/components/Welcome.vue'
import Selftest from '@/components/Selftest.vue'
import DataProtection from '@/components/DataProtection.vue'
import Impressum from '@/components/Impressum.vue'
import Effects from '@/components/Effects.vue'

import Agency from '@/components/Agency.vue'

import Academy from '@/components/Academy.vue'
import Academy_SAT from '@/components/Academy_SAT.vue'
import Academy_HH from '@/components/Academy_HH.vue'
import Academy_KAT from '@/components/Academy_KAT.vue'

import Academy_HAW from '@/components/Academy_HAW.vue'
import Academy_RES from '@/components/Academy_RES.vue'
import Academy_PL from '@/components/Academy_PL.vue'
import Academy_STR from '@/components/Academy_STR.vue'
import Academy_ECOM from '@/components/Academy_ECOM.vue'
import Academy_TD from '@/components/Academy_TD.vue'
import Academy_PRD from '@/components/Academy_PRD.vue'

import Coaching from '@/components/Coaching.vue'
import Coaching_IND from '@/components/Coaching_IND.vue'
import Coaching_TEAM from '@/components/Coaching_TEAM.vue'
import Coaching_PERMA from '@/components/Coaching_PERMA.vue'

import Keynotes from '@/components/Keynotes.vue'
import Keynotes_HW from '@/components/Keynotes_HW.vue'
import Keynotes_LAW from '@/components/Keynotes_LAW.vue'
import Keynotes_PL from '@/components/Keynotes_PL.vue'

import Pub_Podcasts from '@/components/Pub_Podcasts.vue'
import Pub_HAW_Report from '@/components/Pub_HAW_Report.vue'
import Pub_Books from '@/components/Pub_Books.vue'
import Pub_Press from '@/components/Pub_Press.vue'
import Pub_HWS from '@/components/Pub_HWS.vue'

import Contact from '@/components/Contact.vue'

import Survey from '@/components/Survey.vue'

// 1. Define route components.
// These can be imported from other files
//const welcome = { template: Welcome}
//const dataProtection = { template: DataProtection }
//const impressum = { template: Impressum }

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  { path: '/welcome', component: Welcome },

  { path: '/dp', component: DataProtection },
  { path: '/imprint', component: Impressum },

  { path: '/agency', component: Agency },

  { path: '/academy', component: Academy },
  { path: '/academy/workshops_and_seminars', component: Academy_SAT },
    { path: '/academy/happiness_and_work', component: Academy_HAW },
    { path: '/academy/resilience', component: Academy_RES },
    { path: '/academy/positive_leadership', component: Academy_PL },
    { path: '/academy/strengths', component: Academy_STR },
    { path: '/academy/effective_communication', component: Academy_ECOM },
    { path: '/academy/team_development', component: Academy_TD },
  { path: '/academy/happiness_hacks', component: Academy_HH },
  { path: '/academy/knowledge_and_tools', component: Academy_KAT },
  { path: '/academy/products', component: Academy_PRD },

  { path: '/keynotes', component: Keynotes },
  { path: '/keynotes/happiness_works', component: Keynotes_HW },
  { path: '/keynotes/love_and_work', component: Keynotes_LAW},
  { path: '/keynotes/positive_leadership', component: Keynotes_PL },

  { path: '/coaching', component: Coaching },
  { path: '/coaching/individual_coaching', component: Coaching_IND },
  { path: '/coaching/team_coaching', component: Coaching_TEAM},
  { path: '/coaching/perma_lead_coaching', component: Coaching_PERMA }, 

  { path: '/haw/selftest', component: Selftest },
  { path: '/haw/effects', component: Effects },
  { path: '/haw/podcasts', component: Pub_Podcasts },
  { path: '/haw/books', component: Pub_Books },
  { path: '/haw/press', component: Pub_Press },
  { path: '/haw/happiness_and_work_report', component: Pub_HAW_Report },
  { path: '/haw/happiness_and_work_scale', component: Pub_HWS },

 // { path: '/contact', component: Contact, props: true },
  { path: '/contact', component: Contact},
  { path: '/survey/:rid?', component: Survey },
  { path: '*', redirect: '/welcome' }
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  mode: 'history',    // due to SEO 
  //base: '/vue-router',
  //base: __dirname,
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    //console.log("sb from: " + from.fullPath + " to: " + to.fullPath + (savedPosition ? (" savedPosition: " + JSON.stringify(savedPosition)): "")); // eslint-disable-line no-console
    // start timer to scoll to hash position if any in path (e.g. /contact#team) or to top if no hash in path
    setTimeout(() => { 
      if (to.hash) {
        var elem = document.querySelector(to.hash);
        //console.log("afterEach - scoll to: " + to.hash); // eslint-disable-line no-console
        elem.scrollIntoView({ behavior: 'smooth', block: 'start'});
      } else {
        //console.log("afterEach - scoll to: " + to.hash); // eslint-disable-line no-console
        window.scrollTo(0,0);
      }
    }, 1000)
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

/* // called after each page change
router.afterEach((to, from) => {
  console.log("ae from: " + from.fullPath + " to: " + to.fullPath); // eslint-disable-line no-console
  }
) */

// 
// diective to handle click outside events
// can be added to any element to register an action which is triggert if clicked outside the element
// usage: <div v-click-outside="<function>">
Vue.directive('click-outside', {
  priority: 700,
  bind(el, binding, vnode) {
    var vm = vnode.context;
    var callback = binding.value;

    el.clickOutsideEvent = function (event) {
        if (!(el == event.target || el.contains(event.target))) {
            return callback.call(vm, event);
        }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
  }
})

// dynamically update meta tags on each page for SEO
Vue.use(VueMeta, {
  // optional pluginOptions
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: false
})

// initialize and run cookieconsent plugin
// See: https://github.com/orestbida/cookieconsent#all-configuration-options
const consentOptions = CookieConsentConfig
Vue.use(CookieConsent, consentOptions)

// 4. Create and mount the root instance.
// Make sure to inject the router with the router option to make the
// whole app router-aware.
const app = new Vue({  // eslint-disable-line no-unused-vars
  router,
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "- Glück im Kontext von Arbeit.",
    // all metaInfo.title will be injected into this template
    titleTemplate:  chunk => `Happiness & Work ${chunk}`,
    meta: [
      { vmid: "keywords",  name: 'keywords', template:  chunk => `'Ricarda Rehwakdt' Organisation Arbeit Glück Happiness Arbeitszufriedenheit Mitarbeiterzufriedenheit Unternehmenskultur ${chunk}`, content: "Seminar Beratung Coaching Teamentwicklung" },
      { vmid: "description", name: 'description', template: chunk => `Glück im Kontext von Arbeit. ${chunk}`, content: "Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind?"},
      { vmid: "author", name: 'author', content: "Prof. Dr. Ricarda Rehwaldt - FELICICON GmbH"},
      { vmid: "geo.region", name: 'geo.region', content: "DE-BE"},
      { vmid: "geo.placename", name: 'geo.placename', content: "Berlin"},
      // social tagging
      { vmid: "og:title", property: "og:title", template: chunk => `Happiness & Work ${chunk}`, content: "- Glück im Kontext von Arbeit." },
      { vmid: "og:type", property: "og:type", content: "website" },
      { vmid: "og:url", property: "og:url", template: chunk => `https://www.happinessandwork.de${chunk}`, content: "" },
      { vmid: "og:description", property: "og:description", content: "'Happiness & Work' ist ein Projekt der FELICICON GmbH und unterstützt Dich und andere Menschen dabei, einfach etwas glücklicher bei der Arbeit zu sein. Wir zeigen Dir worauf es ankommt und Du erzählst es weiter!" },
      { vmid: "og:author", name: 'og:author', content: "Prof. Dr. Ricarda Rehwaldt - FELICICON GmbH"},
      { vmid: "og:image", name: 'og:image', content: "https://www.happinessandwork.de/share/start.png"}
    ]
  },
  script: [],
  updated: function () {},
  mounted: function () {},
  methods: {
  }
}).$mount('#app')

